import { render } from "./footerComponent.vue?vue&type=template&id=16fa8f33&scoped=true"
import script from "./footerComponent.vue?vue&type=script&lang=js"
export * from "./footerComponent.vue?vue&type=script&lang=js"

import "./footerComponent.vue?vue&type=style&index=0&id=16fa8f33&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fa8f33"]])

export default __exports__